import { useState, useEffect } from 'react';

import Drawer, { DrawerHeader, DrawerFooter } from 'common/components/drawer';
import { FormDrawer } from 'common/components/drawer';
import { FormBody } from 'common/components/drawer';

import { useForm, useActions } from 'utils/hooks';
import { Button } from 'reactstrap';

import * as portActions from 'store/ports/actions';
import selectDataFromState from 'utils/selectDataFromState';

import config from './port/config';
import Port from './port';
import { initializeTimezone } from 'views/enums/ports/form/helpers';
import { selectListOptionsFromStore } from 'store/lists/selectors';
import { useSelector } from 'react-redux';
import { getPortSize } from 'views/enums/ports/form/helpers';
import { useDispatch } from 'react-redux';
import { fetchListOptions } from 'store/lists/actions';

const EditPort = ({ drawer, active, refetchData }) => {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const sizesOptions = useSelector(state => selectListOptionsFromStore(state, 'port-sizes'));

  const [updatePort, createPort] = useActions([portActions.updatePort, portActions.createPort]);
  const { formState, loadValues, handleSubmitError, resetForm, collectValues } = useForm(config);
  const { isOpen } = drawer;
  const dispatch = useDispatch();

  useEffect(() => {
    if (active && isOpen) {
      const { code_synonyms, name_synonyms, timezone, size, ...rest } = active;
      const params = {
        ...rest,
        size: getPortSize(sizesOptions, size),
        synonymsCode: code_synonyms.length
          ? code_synonyms.map(code => ({
              value: code
            }))
          : [{ value: '' }],
        synonymsName: name_synonyms.length
          ? name_synonyms.map(name => ({
              value: name
            }))
          : [{ value: '' }]
      };

      const initialValues = selectDataFromState(
        {
          ...params,
          timezone: initializeTimezone(timezone)?.id
        },
        config
      );

      loadValues({ ...initialValues });
    }

    if (!isOpen) {
      resetForm();
    }
  }, [isOpen, active]);

  const onClose = () => {
    resetForm();
    refetchData();
    drawer.close();
  };

  const submit = async () => {
    const values = collectValues();
    if (!values) return;

    const {
      lat,
      lon,
      synonymsName,
      max_sulfur,
      port_type_id,
      port_area_id,
      synonymsCode,
      id,
      country,
      size,
      type,
      ...rest
    } = values;

    const params = {
      ...rest,
      port_area_id,
      id: active ? active.id : undefined,
      code_synonyms: synonymsCode.filter(item => item.value).map(item => item.value),
      name_synonyms: synonymsName.filter(item => item.value).map(item => item.value),
      lat: lat ? lat : null,
      lon: lon ? lon : null,
      max_sulfur: max_sulfur ? max_sulfur : null,
      table: 'ports',
      country_id: country?.id ? country.id : null,
      size: size?.label || null,
      port_type_id: type?.id || null
    };

    setIsSubmitting(true);

    try {
      if (active) {
        await updatePort(params);
      } else {
        await createPort(params);
      }

      onClose();
    } catch (error) {
      handleSubmitError(error);
    }

    setIsSubmitting(false);
  };

  useEffect(() => {
    dispatch(fetchListOptions('port-sizes'));
  }, [dispatch]);

  return (
    <Drawer {...drawer} className="table-drawer">
      <DrawerHeader className="border-bottom pb-4">
        {active ? 'Edit ' + active.name : 'Add New Port'}
      </DrawerHeader>

      <FormDrawer>
        <FormBody>
          <Port formState={formState} isOpen={isOpen} />
        </FormBody>
      </FormDrawer>

      <DrawerFooter className="d-flex justify-content-end p-3">
        <Button
          color="cancel"
          className="px-0 py-1 me-4"
          onClick={() => drawer.close()}
          disabled={isSubmitting}
        >
          CANCEL
        </Button>
        <Button onClick={submit} disabled={isSubmitting} color="primary" className="px-4">
          SAVE
        </Button>
      </DrawerFooter>
    </Drawer>
  );
};

export default EditPort;
